import React from 'react'

export const CardRateTableSkeleton = () => {
  return (
    <>
      {Array(10)
        .fill(1)
        .map((_, index) => (
          <tr className='border-b bg-transparent border-gray-700' key={index}>
            <td className='p-4'>
              <div className='h-3 w-24 bg-gray-500 rounded-full animate-pulse'></div>{' '}
            </td>
            <td className='p-4'>
              <div className='h-3 w-12 bg-gray-500 rounded-full animate-pulse'></div>
            </td>
          </tr>
        ))}
    </>
  )
}
